import { render } from "./GOOGLE_ANALYTICS.vue?vue&type=template&id=e97df9fa"
import script from "./GOOGLE_ANALYTICS.vue?vue&type=script&lang=js"
export * from "./GOOGLE_ANALYTICS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/data-adapter/GOOGLE_ANALYTICS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e97df9fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e97df9fa', __exports__)) {
    api.reload('e97df9fa', __exports__)
  }
  
  module.hot.accept("./GOOGLE_ANALYTICS.vue?vue&type=template&id=e97df9fa", () => {
    api.rerender('e97df9fa', render)
  })

}


export default __exports__